import { render, staticRenderFns } from "./okupansi_spklu.vue?vue&type=template&id=6bc144ea&scoped=true&"
import script from "./okupansi_spklu.vue?vue&type=script&lang=js&"
export * from "./okupansi_spklu.vue?vue&type=script&lang=js&"
import style0 from "./okupansi_spklu.vue?vue&type=style&index=0&id=6bc144ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc144ea",
  null
  
)

export default component.exports